// extracted by mini-css-extract-plugin
export default {"add":"button-add_add__fzbl3"};